import { makeStyles, withStyles } from "@material-ui/core/styles";
import { weatherTimeWithID, WX_ID_SIGMET } from "../../../store/WeatherContentsState";
import { useRecoilState, useRecoilValue } from "recoil";
import mountainWaveRedImg from "../../../images/contents/map/sigmet/mountain_wave_red.png";
import radioactivityImg from "../../../images/contents/map/sigmet/radioactivity.png";
import typhoonRedImg from "../../../images/contents/map/sigmet/typhoon_red.png";
import unAnalyzedImg from "../../../images/contents/map/sigmet/unanalyzed.png";
import Button from "@material-ui/core/Button";
import { Badge } from "@material-ui/core";
import {
  sigmetUnreadState,
  sigmetUnreadVisibleState
} from "../../../store/SigmetUnreadPositionState";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
    // alignItems: 'center',

  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  iconWrap: {
    display: "inline-block"
  },
  icon: {
    verticalAlign: "middle"
  },
  iconMini: {
    height: "22px"
  },
  iconActual: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ff0000',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconForecast: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #F3D51A',
    margin: '0 auto',
    verticalAlign: "middle"
  },

  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    width:100
  }
}));

const UnreadButton = withStyles({
  sizeSmall: {
    fontSize: '11px'
  }
})(Button)

const UnreadBudge = withStyles({
  colorPrimary: {
    backgroundColor: '#999'
  }
})(Badge);

function LegendSigmet() {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_SIGMET));
  const sigmetUnreadPosition = useRecoilValue(sigmetUnreadState);
  const [sigmetUnreadVisible, setSigmetUnreadVisible] = useRecoilState(sigmetUnreadVisibleState);

  let active;
  let activeBudge;
  if (sigmetUnreadVisible){
    active = 'secondary';
    activeBudge = sigmetUnreadPosition.length > 0 ? 'error' : 'primary';
  } else {
    active = '';
    activeBudge = 'primary';
  }

  const handleUnread = () => {
    setSigmetUnreadVisible(!sigmetUnreadVisible);
  };

  return (
    <div>
      <div className="legend-contents-time">
        {timeInfo.baseTime}
      </div>
      <ul className={classes.box}>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={mountainWaveRedImg} alt="Mountain waves" className={classes.icon}/></span><span className={classes.label}>Mountain waves</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={radioactivityImg} alt="Radioactive" className={classes.icon + ' ' + classes.iconMini}/></span><span className={classes.label}>Radioactive</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={typhoonRedImg} alt="Tropical cyclone" className={classes.icon + ' ' + classes.iconMini}/></span><span className={classes.label}>Tropical cyclone</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={classes.iconActual}></span></span><span className={classes.label}>Actual</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={classes.iconForecast}></span></span><span className={classes.label}>Forecast</span>
        </li>
        <li className={classes.item}>
          <UnreadBudge badgeContent={sigmetUnreadPosition.length} color={activeBudge} showZero>
            <UnreadButton color={active} variant="outlined" size="small" disabled={sigmetUnreadPosition.length === 0} onClick={handleUnread}>
              <span className={classes.iconWrap}><img src={unAnalyzedImg} alt="Unread position" className={classes.icon}/></span><span className={classes.label}>Unread position</span>
            </UnreadButton>
          </UnreadBudge>
        </li>
      </ul>
    </div>
  );
}

export default LegendSigmet;